import source from "@/messages/quiz-embedded-source.json";
import draft from "@/messages/mandarin-quiz-embedded.json";
import type { Locale } from "./locales";
export function quizEmbeddedCopy(locale: Locale = "en"): typeof source {
  return { ...(locale === "en" ? source : draft) };
}
